import * as React from 'react';
import styled from 'styled-components';
import Flex from '@components/layout/flex';

export interface VideoIconProps {
  className?: string;
  size?: number;
  dark?: boolean;
}

export const VideoIcon: React.FC<VideoIconProps> = (props) => (
  <Flex justifyContent="center" alignItems="center" className={props.className}>
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect x="12.5" y="11.8" width="15" height="10" />
      <polyline points="18.5 14.2 18.5 19.2 22.5 16.7 18.5 14.2 " />
      <line x1="12.5" y1="26.8" x2="27.5" y2="26.8" />
      <line x1="15.5" y1="25.2" x2="15.5" y2="28.2" />
    </svg>
  </Flex>
);

export default styled(VideoIcon)`
  width: ${(props) => (props.size ? props.size : '40')}px;
  height: ${(props) => (props.size ? props.size : '40')}px;
  background-color: ${({ theme }) => theme.colors.iconBackground};
  border-radius: ${({ theme }) => theme.general.borderRadius};
  & > svg {
    width: ${(props) => (props.size ? props.size : '40')}px;
    height: ${(props) => (props.size ? props.size : '40')}px;

    line,
    rect,
    polyline {
      fill: none;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-linejoin: round;
      stroke: ${({ theme }) => theme.colors.primary};
    }
  }
`;
